import type { FC } from 'react'
import { match } from 'ts-pattern'
import { Badge } from '~/elements/Badge'
import { cn } from '~/utils'

export type PlanBadgeProps = {
  plan: 'community' | 'team' | 'plus' | 'enterprise'
  className?: string
}

export const PlanBadge: FC<PlanBadgeProps> = ({ plan, className = '' }) => {
  const planMapper = match(plan)
    .with('community', () => ({ style: 'bg-neutral-400 text-white', plan: 'Pay-as-you-go' }))
    .with('team', () => ({ style: 'bg-green-600 dark:bg-green-400 text-white', plan: 'Team' }))
    .with('plus', () => ({ style: 'bg-blue-400 text-white', plan: 'Plus' }))
    .with('enterprise', () => ({ style: 'bg-neutral-950 dark:bg-neutral-100 text-white', plan: 'Enterprise' }))
    .exhaustive()

  return (
    <Badge
      className={cn(
        'inline-flex h-5 items-center justify-center rounded-md px-2 py-0.5 text-sm font-medium whitespace-nowrap',
        planMapper.style,
        className
      )}
    >
      {planMapper.plan}
    </Badge>
  )
}
